import { Progress as ProgressPrimitive } from '@base-ui/react/progress';

import { cn } from '@/lib/utils';

export type ProgressIndicatorProps = ProgressPrimitive.Indicator.Props;

const ProgressIndicator = ({ children, className, ...props }: ProgressIndicatorProps) => {
  return (
    <ProgressPrimitive.Indicator
      data-slot="progress-indicator"
      className={cn(
        'size-full overflow-hidden',
        'data-indeterminate:[&>div]:origin-left data-indeterminate:[&>div]:animate-indeterminate-progress',
      )}
      {...props}
    >
      <div className={cn('size-full bg-gray-600 transition-all', className)}>{children}</div>
    </ProgressPrimitive.Indicator>
  );
};

export default ProgressIndicator;
